import { useEffect } from "react";

import { Header } from "../../components";
import { AppShowcaseSection } from "./components/AppShowcaseSection";
import { ClubStatsSection } from "./components/ClubStatsSection";
import { FaqSection } from "./components/FaqSection";
import { FeatureBadgesSection } from "./components/FeatureBadgesSection";
import { FranchiseExplainer } from "./components/FranchiseExplainer";
import { HeroSection } from "./components/HeroSection";
import { InsuranceMatchSection } from "./components/InsuranceMatchSection";
import { PricingHighlightSection } from "./components/PricingHighlightSection";
import { SavingsSection } from "./components/SavingsSection";
import { ScenariosSection } from "./components/ScenariosSection";
import { StepsSection } from "./components/StepsSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { useZeroFranchiseTracking } from "./hooks/useZeroFranchiseTracking";

export const PackZeroFranchise = () => {
  const { trackPageView } = useZeroFranchiseTracking();

  useEffect(() => {
    trackPageView();
  }, []);

  return (
    <main className="min-h-screen bg-white font-maison text-[#0D0D0D]">
      <div className="bg-[#F5FAFA]">
        <Header className="!bg-white !max-w-[1600px] !mx-auto !justify-center !pr-0 xl:!bg-transparent xl:!justify-between xl:!pr-6" />

        <HeroSection />

        <FranchiseExplainer />
      </div>

      <ScenariosSection />

      <SavingsSection />

      <InsuranceMatchSection />

      <PricingHighlightSection />

      <FeatureBadgesSection />

      <StepsSection />

      <AppShowcaseSection />

      <ClubStatsSection />

      <TestimonialsSection />

      <FaqSection />
    </main>
  );
};
